<div
  class="fn-card-image"
  *ngIf="this.cardInfo"
  [ngClass]="
    this.checkIfItsVisa(this.cardInfo.cardName)
      ? 'fn-card-imageVisa'
      : 'fn-card-imageMaster'
  "
>
  <div class="fn-card-image__content">
    <div class="fn-card-image__content-top">
      <div class="fn-card-image__content-top-logo">
        <img
          *ngIf="this.checkIfItsVisa(this.cardInfo.cardName)"
          class="fn-card-image__content-top-logo-brand"
          alt="Visa"
          src="../../../../../../assets/new-styles/icons/debit-card/visa-icon.svg"
        />
        <img
          *ngIf="!this.checkIfItsVisa(this.cardInfo.cardName)"
          class="fn-card-image__content-top-logo-brand"
          alt="Mastercard"
          src="../../../../../../assets/new-styles/img/card-master.png"
        />
        <span class="fn-card-image__content-top-logo-type"> Débito </span>
      </div>
      <div class="fn-card-image__content-top-options">
        <img
          class="fn-card-image__content-top-options-image"
          alt="Options"
          src="../../../../../../assets/new-styles/img/card-options.png"
          (click)="this.toggleMenuOpen()"
          #toggleButton
        />
        <div class="card-table__menu">
          <div *ngIf="this.isMenuOpen" class="card-table__menu-template" #menu>
            <div class="card-table__menu-arrow"></div>
            <ul class="menu-list" *ngFor="let action of actions">
              <li (click)="onAction(action)">
                {{ "IP.ACTIONS_TOOLTIP." + action.toUpperCase() | translate }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="fn-card-image__content-bottom">
      <div class="fn-card-image__content-bottom-number">
        <span class="fn-card-image__content-bottom-number-dots"> · · · · </span>
        <span>
          {{ this.formatCardNumber(this.cardInfo.cardNumber) }}
        </span>
      </div>
      <div class="fn-card-image__content-bottom-duedate">
        Vence
        {{ this.formatDate(this.cardInfo.expireDate) }}
      </div>
    </div>
  </div>
</div>
